<template>
  <div class="element-value-menu">
    <div>
      <div class="line-docanchor pt-0">
        <h3 class="label m-0">{{ $t("words.initialState") }}</h3>
        <doc-anchor :object="ctx.target" prop="value" />
      </div>
      <input-range
        :min="0"
        :max="100"
        :value="state.value"
        :step="rangeStep"
        @update:value="updateValue"
        @change="ctx.updateKey('value', $event)"
      >
        <template #after="{ value: cachedValue, disabled, onChange }">
          <input-number
            class="input_small"
            :disabled="disabled"
            :value="cachedValue"
            :max="100"
            :min="0"
            step="any"
            @change="onChange"
            @update:value="ctx.updateKey('value', $event)"
          />
        </template>
      </input-range>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, watchEffect, computed } from "vue";
import { useTarget } from "@editor/items/target/useTarget";

import DocAnchor from "@editor/ui/DocumentationAnchor.vue";

import InputRange from "@core/input/InputRange.vue";
import InputNumber from "@core/input/InputNumber.vue";

const props = defineProps<{
  targetId: number;
}>();

const ctx = useTarget(() => props.targetId);

const state = reactive({
  value: ctx.target.value
});

watchEffect(() => {
  if (ctx.target) {
    updateValue(ctx.target.value);
  }
});

const rangeStep = computed(() => {
  const maxDecimalPoints = (ctx.target.value + "").split(".")[1]?.length ?? 0;
  if (maxDecimalPoints > 0) {
    return 1 / Math.pow(10, maxDecimalPoints);
  }
  return 1;
});

function updateValue(newVal: number) {
  state.value = newVal;
}
</script>

<style lang="scss">
.element-value-menu {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
